// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FileText, RefreshCw } from 'lucide-react';
// import axios from 'axios';
// import Sidebar from "../../Temp/Sidebar/Sidebar";
// import { useAuthorization } from "../hooks/useAuthorizations";
// import '../../css/Updatedstyles.css';
// import '../../Final_Css/positiveflowbuttons.css';
// import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
// import { FaEdit, FaEye, FaPen } from "react-icons/fa";
// import { Box, TextField, Tooltip, IconButton } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import CloseIcon from "@mui/icons-material/Close";
// import { useOutletContext, Navigate, useLocation } from "react-router-dom";

// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";



// import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
// import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

// // Debounce utility
// const debounce = (func, delay) => {
//   let timer;
//   return (...args) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => func(...args), delay);
//   };
// };

// export default function ListofExams({ isLookup = false, onSelectExam, apiUrl }) {
//   const navigate = useNavigate();
//   const { permissionLevel, loading: authLoading } = useAuthorization();
//   const { permissionSet, permissionsLoading } = useOutletContext();

//   const canAccessAssessment = permissionSet.has(5) || permissionSet.has(6);
//   // Data states
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [isRefreshing, setIsRefreshing] = useState(false);
//   const [totalPages, setTotalPages] = useState(1);
//   const [currentPage, setCurrentPage] = useState(1);


//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   // Filter states
//   const [searchQuery, setSearchQuery] = useState('');
//   const [statusFilter, setStatusFilter] = useState('Published'); // 'Published' or 'Draft'
//   const [showFilters, setShowFilters] = useState(false);
//   const [filterRule, setFilterRule] = useState(null); // applied rule

//   // Sorting (client-side on current page)
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

//   // Refs for uncontrolled QueryBuilder
//   const qbRef = useRef(null);
//   const currentRuleRef = useRef(null);

//   const rowsPerPage = 10;
//   const API_URL = apiUrl || `/manager/exam-details/`;


//   // Convert status to backend value (1 = Published, 0 = Draft)
//   const getStatusValue = () => (statusFilter === 'Published' ? 1 : 0);



//   // Fetch exams with filters, search, status, pagination
//   const fetchExams = useCallback(
//     async (rule = null, search = '', status = getStatusValue(), page = currentPage) => {
//       if (isRefreshing) return;
//       setIsRefreshing(true);
//       setLoading(true);

//       try {
//         const params = {
//           page,
//           pageSize: rowsPerPage,
//           status,
//         };
//         if (search.trim()) params.search = search;
//         if (rule && rule.rules?.length) params.filters = JSON.stringify(rule);

//         if (fromDate) {
//           params.from_date = fromDate;
//         }

//         if (toDate) {
//           params.to_date = toDate;
//         }


//         if (rule && rule.rules?.length) {
//           params.filters = JSON.stringify(rule);
//         }

//         const res = await axios.get(API_URL, { params });
//         const fetchedRows = Array.isArray(res.data.results) ? res.data.results : [];
//         setRows(fetchedRows);
//         console.log(fetchedRows, "fetched")
//         setTotalPages(res.data.totalPages || 1);
//       } catch (err) {
//         console.error('Failed to fetch exams:', err);
//         setRows([]);
//         setTotalPages(1);
//       } finally {
//         setLoading(false);
//         setIsRefreshing(false);
//       }
//     },
//     [isRefreshing, currentPage, rowsPerPage, statusFilter, fromDate,
//     toDate]
//   );

//   // Debounced search to avoid too many requests
//   const debouncedFetch = useCallback(
//     debounce((rule, search, status, page) => fetchExams(rule, search, status, page), 500),
//     [fetchExams]
//   );

//   // Trigger fetch when dependencies change
//   // useEffect(() => {
//   //   debouncedFetch(filterRule, searchQuery, getStatusValue(), currentPage);
//   // }, [currentPage, filterRule, searchQuery, statusFilter]);

//   useEffect(() => {
//     debouncedFetch(
//       filterRule,
//       searchQuery,
//       getStatusValue(),
//       currentPage
//     );
//   }, [
//     currentPage,
//     filterRule,
//     searchQuery,
//     statusFilter,
//     fromDate,
//     toDate
//   ]);

//   const stringOperators = [
//     { value: 'contains', key: 'Contains' },
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'startswith', key: 'Starts With' },
//     { value: 'endswith', key: 'Ends With' },
//     { value: 'isempty', key: 'Is Empty' },
//     { value: 'isnotempty', key: 'Is Not Empty' }
//   ];

//   const numberOperators = [
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'greaterthan', key: 'Greater Than' },
//     { value: 'lessthan', key: 'Less Than' }
//   ];

//   const dateOperators = [
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'greaterthan', key: 'After' },
//     { value: 'lessthan', key: 'Before' },
//     { value: 'greaterthanorequal', key: 'On or After' },
//     { value: 'lessthanorequal', key: 'On or Before' },
//     { value: 'between', key: 'Between' }
//   ];

//   const queryBuilderColumns = [
//     { field: 'Title', label: 'Title', type: 'string', operators: stringOperators },
//     { field: 'ExamNumber', label: 'Exam Number', type: 'string', operators: stringOperators },
//     { field: 'ExamType', label: 'Exam Type', type: 'string', operators: stringOperators },
//     { field: 'Genre', label: 'Genre', type: 'string', operators: stringOperators },
//     { field: 'Difficulty', label: 'Difficulty', type: 'string', operators: stringOperators },
//     { field: 'CreatedOn', label: 'Created On', type: 'date', format: 'dd-MM-yyyy', operators: dateOperators },
//     { field: 'CreatedBy', label: 'Created By', type: 'string', operators: stringOperators }
//   ].sort((a, b) => a.label.localeCompare(b.label));

//   const defaultRule = { condition: 'and', rules: [] };

//   const applyFilters = () => {
//     const rule = currentRuleRef.current || defaultRule;
//     console.log("Applied Rule:", JSON.stringify(rule, null, 2));

//     setFilterRule(rule);
//     setCurrentPage(1);
//     fetchExams(rule, searchQuery, getStatusValue(), 1);
//   };

//   // const clearAllFilters = () => {
//   //   setSearchQuery('');
//   //   setFilterRule(null);
//   //   setStatusFilter('Published');
//   //   setCurrentPage(1);
//   //   if (qbRef.current) {
//   //     qbRef.current.setRules(defaultRule);
//   //     currentRuleRef.current = defaultRule;
//   //   }
//   //   fetchExams(null, '', 1, 1);
//   // };


//   const clearAllFilters = () => {
//     setSearchQuery('');
//     setFilterRule(null);
//     setStatusFilter('Published');
//     setFromDate('');
//     setToDate('');
//     setCurrentPage(1);

//     if (qbRef.current) {
//       qbRef.current.setRules(defaultRule);
//       currentRuleRef.current = defaultRule;
//     }

//     // fetchExams(null, '', 1, 1);

//     setFromDate('');
//   setToDate('');
//   setCurrentPage(1);
//     setSearchQuery('');
//   };

//   const handleRefresh = () => {
//     clearAllFilters();
//   };

//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   const sortedRows = [...rows].sort((a, b) => {
//     if (!sortConfig.key) return 0;
//     const aVal = a[sortConfig.key] ?? '';
//     const bVal = b[sortConfig.key] ?? '';
//     const compare = String(aVal).localeCompare(String(bVal));
//     return sortConfig.direction === 'asc' ? compare : -compare;
//   });

//   const pageNumbers = [];
//   for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) setCurrentPage(page);
//   };


//   const formatDate = (date) => {
//   if (!date) return "";

//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");

//   return `${year}-${month}-${day}`;
// };

//   const handleRowClick = (exam, e) => {
//     if (e?.target?.closest('.action-wrapper')) {
//       return;
//     }
//     if (isLookup && onSelectExam) {
//       onSelectExam(exam);
//     } else {
//       // Row click = view mode
//       navigate(`/managers/create-course/${exam.ExamTypeId}/${exam.Id}`, {
//         state: { mode: 'view' }
//       });
//     }
//   };

//   if (permissionsLoading) return <div>Loading...</div>;

//   if (!isLookup && !canAccessAssessment) {
//     return <Navigate to="/error" replace />;
//   }
//   // Disable future dates for all Syncfusion DatePickers inside the QueryBuilder
//   // const disableFutureDates = () => {
//   //   // Give time for the DOM to update
//   //   setTimeout(() => {
//   //     const datePickers = document.querySelectorAll('.e-datepicker');
//   //     datePickers.forEach(picker => {
//   //       const instance = picker.ej2_instances?.[0];
//   //       if (instance && instance.max !== new Date().toISOString()) {
//   //         instance.max = new Date(); // set max to today
//   //       }
//   //     });
//   //   }, 100);
//   // };

//   // Disable future dates and prevent End Date < Start Date
//   const disableFutureDates = () => {
//     setTimeout(() => {
//       const datePickers = document.querySelectorAll('.e-datepicker');

//       datePickers.forEach((picker, index) => {
//         const instance = picker.ej2_instances?.[0];

//         if (instance) {
//           // Disable future dates
//           instance.max = new Date();

//           // Handle BETWEEN operator
//           // First picker = Start Date
//           // Second picker = End Date
//           if (datePickers.length >= 2 && index === 1) {
//             const startPicker = datePickers[0].ej2_instances?.[0];

//             if (startPicker?.value) {
//               // End date cannot be earlier than start date
//               instance.min = new Date(startPicker.value);
//             }
//           }
//         }
//       });
//     }, 100);
//   };


//   return (
//     <div className="flex min-h-screen">
//       {/* <div className="w-[95px] flex-shrink-0">
//         <Sidebar />
//       </div> */}

//       <div className="flex-1 overflow-auto pl-6 pr-6 pt-6">
//         <div className="pd-overview-container">


//           {!isLookup && (
//             <div className="pd-header">
//               <div className="pd-title-section">
//                 <h1 className="pd-title">Exam Configuration</h1>
//                 <FileText className="pd-title-icon" />
//               </div>
//               <div className="flex items-center gap-4">
//                 <button onClick={handleRefresh} disabled={isRefreshing}>
//                   <RefreshCw
//                     size={18}
//                     className={`pd-refresh-icon ${isRefreshing ? 'pd-rotating' : ''}`}
//                   />
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* SEARCH, FILTER TOGGLE, STATUS TABS */}
//           <Box className="pd-controls" sx={{ p: '10px 15px', borderRadius: '6px', mb: 2 }}>

//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 2 }}>
//               <TextField
//                 size="small"
//                 placeholder="Search by Title, Exam Number, Exam Type, Created On, Created By...."
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 sx={{ width: 320, minWidth: { xs: '100%', sm: 320 } }}
//                 InputProps={{ startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} /> }}
//               />
//               {/* <ButtonComponent
//                 cssClass="btn"
//                 onClick={() => {
//                   if (showFilters) {
//                     if (qbRef.current) {
//                       qbRef.current.setRules(defaultRule);
//                       currentRuleRef.current = defaultRule;
//                     }

//                     setFilterRule(null);
//                     setSearchQuery('');
//                     setCurrentPage(1);

//                     fetchExams(null, '', getStatusValue(), 1);
//                   }

//                   setShowFilters(!showFilters);
//                 }}
//               >
//                 {showFilters ? 'Close Filters' : 'Enable Filters'}
//               </ButtonComponent> */}


//               <ButtonComponent
//                 cssClass="btn"
//                 onClick={() => {
//                   if (showFilters) {
//                     if (qbRef.current) {
//                       qbRef.current.setRules(defaultRule);
//                       currentRuleRef.current = defaultRule;
//                     }

//                     setFilterRule(null);
//                     setSearchQuery('');
//                     setCurrentPage(1);
//                     setFromDate('');
//                     setToDate('');

//                     // fetchExams(null, '', getStatusValue(), 1);
//                     setFilterRule(null);
//                     setSearchQuery('');
//                     setFromDate('');
//                     setToDate('');
//                     setCurrentPage(1);
//                   }

//                   setShowFilters(!showFilters);
//                 }}
//               >
//                 {showFilters ? "Close Filters" : "Enable Filters"}
//               </ButtonComponent>



//               {/* {showFilters && (
//   <LocalizationProvider dateAdapter={AdapterDateFns}>
//     <DatePicker
//       label="From Date"
//       value={fromDate ? new Date(fromDate) : null}
//       maxDate={new Date()}
//       onChange={(newValue) => {
//         setFromDate(
//           newValue ? newValue.toISOString().split("T")[0] : ""
//         );
//       }}
//       slotProps={{
//         textField: {
//           size: "small",
//           sx: { width: 180 }
//         }
//       }}
//     />

//     <DatePicker
//       label="To Date"
//       value={toDate ? new Date(toDate) : null}
//       minDate={fromDate ? new Date(fromDate) : undefined}
//       maxDate={new Date()}
//       onChange={(newValue) => {
//         setToDate(
//           newValue ? newValue.toISOString().split("T")[0] : ""
//         );
//       }}
//       slotProps={{
//         textField: {
//           size: "small",
//           sx: { width: 180 }
//         }
//       }}
//     />
//   </LocalizationProvider>
// )} */}

//             </Box>

//             {!isLookup && (
//               <Box
//                 sx={{
//                   display: 'flex',
//                   gap: 1,
//                   flexWrap: { xs: 'wrap', sm: 'nowrap' },
//                   borderRadius: '13px',
//                   overflow: 'hidden'
//                 }}
//               >
//                 <button
//                   onClick={() => setStatusFilter('Published')}
//                   className={`tab-btn ${statusFilter === 'Published' ? 'active' : ''}`}
//                   style={{ flex: 1, textAlign: 'center' }}
//                 >
//                   Published Exams
//                 </button>
//                 <button
//                   onClick={() => setStatusFilter('Draft')}
//                   className={`tab-btn ${statusFilter === 'Draft' ? 'active' : ''}`}
//                   style={{ flex: 1, textAlign: 'center' }}
//                 >
//                   Draft Exams
//                 </button>
//               </Box>
//             )}
//           </Box>

//           {/* SYNCFFUSION QUERYBUILDER */}
//           {showFilters && (
//             <div style={{ marginBottom: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '8px' }}>
//               {showFilters && (
//                 <div
//                   style={{
//                     marginBottom: "1px",
//                     padding: "10px",
//                     background: "#f5f5f5",
//                     borderRadius: "8px",
//                     position: "relative"
//                   }}
//                 >

//                   {/* Top Right Date Filters */}
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: "30px",
//                       right: "15px",
//                       display: "flex",
//                       gap: "10px",
//                       zIndex: 1000
//                     }}
//                   >
//                     <LocalizationProvider dateAdapter={AdapterDateFns}>
//                       <DatePicker
//                         label="From Date"
//                         value={fromDate ? new Date(fromDate) : null}
//                         maxDate={new Date()}
//                         onChange={(newValue) => {
//   setFromDate(formatDate(newValue));
// }}
//                         slotProps={{
//                           textField: {
//                             size: "small",
//                             sx: { width: 170 }
//                           }
//                         }}
//                       />

//                       <DatePicker
//                         label="To Date"
//                         value={toDate ? new Date(toDate) : null}
//                         minDate={fromDate ? new Date(fromDate) : undefined}
//                         maxDate={new Date()}
//                       onChange={(newValue) => {
//   setToDate(formatDate(newValue));
// }}
//                         slotProps={{
//                           textField: {
//                             size: "small",
//                             sx: { width: 170 }
//                           }
//                         }}
//                       />
//                     </LocalizationProvider>
//                   </div>





//                 </div>
//               )}
//               <QueryBuilderComponent
//                 ref={qbRef}
//                 dataSource={[]}
//                 columns={queryBuilderColumns}
//                 rule={defaultRule}
//                 ruleChange={(args) => {
//                   currentRuleRef.current = args.rule;
//                   disableFutureDates();  // 👈 call after rule changes
//                 }}
//                 created={() => {
//                   if (qbRef.current) {
//                     qbRef.current.setRules(defaultRule);
//                     disableFutureDates(); // 👈 call initially
//                   }
//                 }}

//                 showButtons={false}
//                 summaryView={false}
//               />
//               <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
//                 <ButtonComponent
//                   cssClass="btn-negative"
//                   onClick={() => {
//                     if (qbRef.current) {
//                       qbRef.current.setRules(defaultRule);
//                       currentRuleRef.current = defaultRule;
//                     }
//                     setFilterRule(null);
//                     setSearchQuery('');
//                     setCurrentPage(1);
//                     // fetchExams(null, '', getStatusValue(), 1);
//                     setFilterRule(null);
//                     setSearchQuery('');
//                     setFromDate('');
//                     setToDate('');
//                     setCurrentPage(1);
//                   }}

//                 >
//                   Clear Filters
//                 </ButtonComponent>
//                 <ButtonComponent cssClass="btn" onClick={applyFilters}>
//                   Apply Filters
//                 </ButtonComponent>
//               </Box>
//             </div>
//           )}

//           {/* TABLE */}
//           <div className="pd-table-container">
//             {loading ? (
//               <div className="pd-table-loading">
//                 <div className="pd-table-loading-animation">
//                   <img
//                     className="pd-table-loading-video"
//                     src="/images/breath1.gif"
//                     alt="Loading exams..."
//                   />
//                   <p>Loading exams...</p>
//                 </div>
//               </div>
//             ) : sortedRows.length === 0 ? (
//               <div className="pd-no-data">No {statusFilter.toLowerCase()} exams found</div>
//             ) : (
//               <div className="pd-table-wrapper">
//                 <table className="pd-table">
//                   <thead>
//                     <tr>
//                       <th className="sortable-th">
//                         <div className="th-wrapper">
//                           <span className="th-title">Title</span>

//                         </div>
//                       </th>
//                       <th className="sortable-th">
//                         <div className="th-wrapper">
//                           <span className="th-title">Exam Number</span>

//                         </div>
//                       </th>

//                       <th className="sortable-th">
//                         <div className="th-wrapper">
//                           <span className="th-title">Exam Type</span>

//                         </div>
//                       </th>

//                       <th>
//                         <div className="th-wrapper">
//                           <span className="th-title">Genre</span>
//                         </div>
//                       </th>

//                       <th>
//                         <div className="th-wrapper">
//                           <span className="th-title">Difficulty</span>
//                         </div>
//                       </th>

//                       <th className="sortable-th">
//                         <div className="th-wrapper">
//                           <span className="th-title">Created On</span>

//                         </div>
//                       </th>
//                       <th className="sortable-th">
//                         <div className="th-wrapper">
//                           <span className="th-title">Created By</span>

//                         </div>
//                       </th>
//                       {/* <th>Actions</th> */}
//                       {!isLookup && <th>Actions</th>}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {sortedRows.map((exam, idx) => (
//                       <tr
//                         key={idx}
//                         onClick={(e) => handleRowClick(exam, e)}
//                         style={{ cursor: 'pointer' }}
//                         className="selectable-row"
//                       >
//                         <td>{exam.Title || 'Untitled'}</td>
//                         <td>{exam.ExamNumber || 'N/A'}</td>

//                         <td>{exam.ExamType || '-'}</td>
//                         <td>{exam.Genre || '-'}</td>
//                         <td>{exam.Difficulty || '-'}</td>
//                         {/* <td>
//                           {exam.Created_On
//                             ? new Date(exam.Created_On).toISOString().split('T')[0]
//                             : '-'}
//                         </td> */}
//                         <td>
//   {exam.Created_On
//     ? new Date(exam.Created_On)
//         .toLocaleDateString('en-GB')
//         .replace(/\//g, '-')
//     : '-'}
// </td>
//                         <td> {exam.Created_By_Name || '-'}</td>
//                         {!isLookup && (
//                           <td onClick={(e) => e.stopPropagation()}>
//                             <div className="action-wrapper">
//                               {!authLoading && permissionLevel >= 1 && (
//                                 <button
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     navigate(`/managers/create-course/${exam.ExamTypeId}/${exam.Id}`, {
//                                       state: { mode: 'edit' }
//                                     });
//                                   }}
//                                   className="pd-action-btn action-btn"
//                                   title={permissionLevel === 2 ? 'Edit' : 'View'}
//                                 >
//                                   {permissionLevel === 2 ? (
//                                     <FaPen className="action-icon" />
//                                   ) : (
//                                     <FaEye className="action-icon" />
//                                   )}
//                                 </button>
//                               )}
//                             </div>
//                           </td>
//                         )}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>

//           {/* PAGINATION */}
//           {!loading && totalPages > 1 && (
//             <div className="pd-pagination">
//               <button
//                 className="btn-negative"
//                 disabled={currentPage === 1}
//                 onClick={() => handlePageChange(currentPage - 1)}
//               >
//                 Previous
//               </button>
//               <div className="pd-page-numbers">
//                 {pageNumbers.map((num) => (
//                   <button
//                     key={num}
//                     className={`pg-type-btn ${currentPage === num ? 'active' : ''}`}
//                     onClick={() => handlePageChange(num)}
//                   >
//                     {num}
//                   </button>
//                 ))}
//               </div>
//               <button
//                 className="btn-negative"
//                 disabled={currentPage === totalPages}
//                 onClick={() => handlePageChange(currentPage + 1)}
//               >
//                 Next
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }











import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, RefreshCw } from 'lucide-react';
import axios from 'axios';
import Sidebar from "../../Temp/Sidebar/Sidebar";
import { useAuthorization } from "../hooks/useAuthorizations";
import '../../css/Updatedstyles.css';
import '../../Final_Css/positiveflowbuttons.css';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import { FaEdit, FaEye, FaPen } from "react-icons/fa";
import { Box, TextField, Tooltip, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useOutletContext, Navigate, useLocation } from "react-router-dom";
 
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
 
 
 
import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import TableEmptyRow from '../../shared/TableEmptyRow';
 
// Debounce utility
const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};
 
export default function ListofExams({ isLookup = false, onSelectExam, apiUrl }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { permissionLevel, loading: authLoading } = useAuthorization();
  const { permissionSet, permissionsLoading } = useOutletContext();
 
  const canAccessAssessment = permissionSet.has(5) || permissionSet.has(6);
  // Data states
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
 
 
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
 
  // Filter states
  const [searchQuery, setSearchQuery] = useState('');
  // const [statusFilter, setStatusFilter] = useState('Published'); // 'Published' or 'Draft'
  const [statusFilter, setStatusFilter] = useState(location.state?.statusFilter || 'Published');
  const [showFilters, setShowFilters] = useState(false);
  const [filterRule, setFilterRule] = useState(null); // applied rule
 
  // Sorting (client-side on current page)
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
 
  // Refs for uncontrolled QueryBuilder
  const qbRef = useRef(null);
  const currentRuleRef = useRef(null);
 
  const rowsPerPage = 10;
  const API_URL = apiUrl || `/manager/exam-details/`;
 
 
  // Convert status to backend value (1 = Published, 0 = Draft)
  const getStatusValue = () => (statusFilter === 'Published' ? 1 : 0);
 
 
 
  // Fetch exams with filters, search, status, pagination
  const fetchExams = useCallback(
    async (rule = null, search = '', status = getStatusValue(), page = currentPage) => {
      if (isRefreshing) return;
      setIsRefreshing(true);
      setLoading(true);
 
      try {
        const params = {
          page,
          pageSize: rowsPerPage,
          status,
        };
        if (search.trim()) params.search = search;
        if (rule && rule.rules?.length) params.filters = JSON.stringify(rule);
 
        if (fromDate) {
          params.from_date = fromDate;
        }
 
        if (toDate) {
          params.to_date = toDate;
        }
 
 
        if (rule && rule.rules?.length) {
          params.filters = JSON.stringify(rule);
        }
 
        const res = await axios.get(API_URL, { params });
        const fetchedRows = Array.isArray(res.data.results) ? res.data.results : [];
        setRows(fetchedRows);
        console.log(fetchedRows, "fetched")
        setTotalPages(res.data.totalPages || 1);
      } catch (err) {
        console.error('Failed to fetch exams:', err);
        setRows([]);
        setTotalPages(1);
      } finally {
        setLoading(false);
        setIsRefreshing(false);
      }
    },
    [isRefreshing, currentPage, rowsPerPage, statusFilter, fromDate,
    toDate]
  );
 
  // Debounced search to avoid too many requests
  const debouncedFetch = useCallback(
    debounce((rule, search, status, page) => fetchExams(rule, search, status, page), 500),
    [fetchExams]
  );
 
  // Trigger fetch when dependencies change
  // useEffect(() => {
  //   debouncedFetch(filterRule, searchQuery, getStatusValue(), currentPage);
  // }, [currentPage, filterRule, searchQuery, statusFilter]);
 
  useEffect(() => {
    debouncedFetch(
      filterRule,
      searchQuery,
      getStatusValue(),
      currentPage
    );
  }, [
    currentPage,
    filterRule,
    searchQuery,
    statusFilter,
    fromDate,
    toDate
  ]);
  useEffect(() => {
  if (location.state?.statusFilter) {
    setStatusFilter(location.state.statusFilter);
  }
}, [location.state]);
 
  const stringOperators = [
    { value: 'contains', key: 'Contains' },
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'startswith', key: 'Starts With' },
    { value: 'endswith', key: 'Ends With' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];
 
  const numberOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'Greater Than' },
    { value: 'lessthan', key: 'Less Than' }
  ];
 
  const dateOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'After' },
    { value: 'lessthan', key: 'Before' },
    { value: 'greaterthanorequal', key: 'On or After' },
    { value: 'lessthanorequal', key: 'On or Before' },
    { value: 'between', key: 'Between' }
  ];
 
  const queryBuilderColumns = [
    { field: 'Title', label: 'Title', type: 'string', operators: stringOperators },
    { field: 'ExamNumber', label: 'Exam Number', type: 'string', operators: stringOperators },
    { field: 'ExamType', label: 'Exam Type', type: 'string', operators: stringOperators },
    { field: 'Genre', label: 'Genre', type: 'string', operators: stringOperators },
    { field: 'Difficulty', label: 'Difficulty', type: 'string', operators: stringOperators },
    { field: 'CreatedOn', label: 'Created On', type: 'date', format: 'dd-MM-yyyy', operators: dateOperators },
    { field: 'CreatedBy', label: 'Created By', type: 'string', operators: stringOperators }
  ].sort((a, b) => a.label.localeCompare(b.label));
 
  const defaultRule = { condition: 'and', rules: [] };
 
  const applyFilters = () => {
    const rule = qbRef.current?.getValidRules() || defaultRule;
 
    console.log("Applied Rule:", JSON.stringify(rule, null, 2));
 
    setFilterRule(rule);
    setCurrentPage(1);
  };
 
  // const clearAllFilters = () => {
  //   setSearchQuery('');
  //   setFilterRule(null);
  //   setStatusFilter('Published');
  //   setCurrentPage(1);
  //   if (qbRef.current) {
  //     qbRef.current.setRules(defaultRule);
  //     currentRuleRef.current = defaultRule;
  //   }
  //   fetchExams(null, '', 1, 1);
  // };
 
 
  const clearAllFilters = () => {
    setSearchQuery('');
    setFilterRule(null);
    setStatusFilter('Published');
    setFromDate('');
    setToDate('');
    setCurrentPage(1);
 
    if (qbRef.current) {
      qbRef.current.setRules(defaultRule);
      currentRuleRef.current = defaultRule;
    }
 
    fetchExams(null, '', 1, 1);
 
  };
 
  const handleRefresh = () => {
    clearAllFilters();
  };
 
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
 
  const sortedRows = [...rows].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aVal = a[sortConfig.key] ?? '';
    const bVal = b[sortConfig.key] ?? '';
    const compare = String(aVal).localeCompare(String(bVal));
    return sortConfig.direction === 'asc' ? compare : -compare;
  });
 
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
 
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };
 
 
  const formatDate = (date) => {
  if (!date) return "";
 
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
 
  return `${year}-${month}-${day}`;
};
 
  const handleRowClick = (exam, e) => {
    if (e?.target?.closest('.action-wrapper')) {
      return;
    }
    if (isLookup && onSelectExam) {
      onSelectExam(exam);
    } else {
      // Row click = view mode
      navigate(`/managers/create-course/${exam.ExamTypeId}/${exam.Id}`, {
        state: { mode: 'view' }
      });
    }
  };
 
  if (permissionsLoading) return <div>Loading...</div>;
 
  if (!isLookup && !canAccessAssessment) {
    return <Navigate to="/error" replace />;
  }
  // Disable future dates for all Syncfusion DatePickers inside the QueryBuilder
  // const disableFutureDates = () => {
  //   // Give time for the DOM to update
  //   setTimeout(() => {
  //     const datePickers = document.querySelectorAll('.e-datepicker');
  //     datePickers.forEach(picker => {
  //       const instance = picker.ej2_instances?.[0];
  //       if (instance && instance.max !== new Date().toISOString()) {
  //         instance.max = new Date(); // set max to today
  //       }
  //     });
  //   }, 100);
  // };
 
  // Disable future dates and prevent End Date < Start Date
  const disableFutureDates = () => {
    setTimeout(() => {
      const datePickers = document.querySelectorAll('.e-datepicker');
 
      datePickers.forEach((picker, index) => {
        const instance = picker.ej2_instances?.[0];
 
        if (instance) {
          // Disable future dates
          instance.max = new Date();
 
          // Handle BETWEEN operator
          // First picker = Start Date
          // Second picker = End Date
          if (datePickers.length >= 2 && index === 1) {
            const startPicker = datePickers[0].ej2_instances?.[0];
 
            if (startPicker?.value) {
              // End date cannot be earlier than start date
              instance.min = new Date(startPicker.value);
            }
          }
        }
      });
    }, 100);
  };
 
 
  return (
    <div className="flex min-h-screen">
      {/* <div className="w-[95px] flex-shrink-0">
        <Sidebar />
      </div> */}
 
      <div className="flex-1 overflow-auto pl-6 pr-6 pt-6">
        <div className="pd-overview-container">
 
 
          {!isLookup && (
            <div className="pd-header">
              <div className="pd-title-section">
                <h1 className="pd-title">Exam Configuration</h1>
                <FileText className="pd-title-icon" />
              </div>
              <div className="flex items-center gap-4">
                <button onClick={handleRefresh} disabled={isRefreshing}>
                  <RefreshCw
                    size={18}
                    className={`pd-refresh-icon ${isRefreshing ? 'pd-rotating' : ''}`}
                  />
                </button>
              </div>
            </div>
          )}
 
          {/* SEARCH, FILTER TOGGLE, STATUS TABS */}
          <Box className="pd-controls" sx={{ p: '10px 15px', borderRadius: '6px', mb: 2 }}>
 
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 2 }}>
              <TextField
                size="small"
                placeholder="Search by Title, Exam Number, Exam Type, Genre, Difficulty, Created On, Created By...."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
                sx={{ width: 800, minWidth: { xs: '100%', sm: 320 } }}
                InputProps={{ startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} /> }}
              />
              {/* <ButtonComponent
                cssClass="btn"
                onClick={() => {
                  if (showFilters) {
                    if (qbRef.current) {
                      qbRef.current.setRules(defaultRule);
                      currentRuleRef.current = defaultRule;
                    }
 
                    setFilterRule(null);
                    setSearchQuery('');
                    setCurrentPage(1);
 
                    fetchExams(null, '', getStatusValue(), 1);
                  }
 
                  setShowFilters(!showFilters);
                }}
              >
                {showFilters ? 'Close Filters' : 'Enable Filters'}
              </ButtonComponent> */}
 
 
              <ButtonComponent
                cssClass="btn"
                onClick={() => {
                  if (showFilters) {
                    if (qbRef.current) {
                      qbRef.current.setRules(defaultRule);
                      currentRuleRef.current = defaultRule;
                    }
 
                    setFilterRule(null);
                    setSearchQuery('');
                    setCurrentPage(1);
                    setFromDate('');
                    setToDate('');
 
                    // fetchExams(null, '', getStatusValue(), 1);
                    fetchExams(null, "", getStatusValue(), 1);
                  }
 
                  setShowFilters(!showFilters);
                }}
              >
                {showFilters ? "Close Filters" : "Enable Filters"}
              </ButtonComponent>
 
 
 
              {/* {showFilters && (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <DatePicker
      label="From Date"
      value={fromDate ? new Date(fromDate) : null}
      maxDate={new Date()}
      onChange={(newValue) => {
        setFromDate(
          newValue ? newValue.toISOString().split("T")[0] : ""
        );
      }}
      slotProps={{
        textField: {
          size: "small",
          sx: { width: 180 }
        }
      }}
    />
 
    <DatePicker
      label="To Date"
      value={toDate ? new Date(toDate) : null}
      minDate={fromDate ? new Date(fromDate) : undefined}
      maxDate={new Date()}
      onChange={(newValue) => {
        setToDate(
          newValue ? newValue.toISOString().split("T")[0] : ""
        );
      }}
      slotProps={{
        textField: {
          size: "small",
          sx: { width: 180 }
        }
      }}
    />
  </LocalizationProvider>
)} */}
 
            </Box>
 
            {!isLookup && (
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                  borderRadius: '13px',
                  overflow: 'hidden'
                }}
              >
                <button
                  onClick={() => setStatusFilter('Published')}
                  className={`tab-btn ${statusFilter === 'Published' ? 'active' : ''}`}
                  style={{ flex: 1, textAlign: 'center' }}
                >
                  Published Exams
                </button>
                <button
                  onClick={() => setStatusFilter('Draft')}
                  className={`tab-btn ${statusFilter === 'Draft' ? 'active' : ''}`}
                  style={{ flex: 1, textAlign: 'center' }}
                >
                  Draft Exams
                </button>
              </Box>
            )}
          </Box>
 
          {/* SYNCFFUSION QUERYBUILDER */}
          {showFilters && (
            <div style={{ marginBottom: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '8px' }}>
              {showFilters && (
                <div
                  style={{
                    marginBottom: "1px",
                    padding: "10px",
                    background: "#f5f5f5",
                    borderRadius: "8px",
                    position: "relative"
                  }}
                >
 
                  {/* Top Right Date Filters */}
                  <div
                    style={{
                      position: "absolute",
                      top: "30px",
                      right: "15px",
                      display: "flex",
                      gap: "10px",
                      zIndex: 1000
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="From Date"
                         format="dd/MM/yyyy"
                        value={fromDate ? new Date(fromDate) : null}
                        maxDate={new Date()}
                        onChange={(newValue) => {
  setFromDate(formatDate(newValue));
}}
                        slotProps={{
                          textField: {
                            size: "small",
                            sx: { width: 170 }
                          }
                        }}
                      />
 
                      <DatePicker
                        label="To Date"
                         format="dd/MM/yyyy"
                        value={toDate ? new Date(toDate) : null}
                        minDate={fromDate ? new Date(fromDate) : undefined}
                        maxDate={new Date()}
                      onChange={(newValue) => {
  setToDate(formatDate(newValue));
}}
                        slotProps={{
                          textField: {
                            size: "small",
                            sx: { width: 170 }
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </div>
 
 
 
 
 
                </div>
              )}
              <QueryBuilderComponent
                ref={qbRef}
                dataSource={[]}
                columns={queryBuilderColumns}
                rule={defaultRule}
                ruleChange={(args) => {
                  currentRuleRef.current = args.rule;
                  disableFutureDates();  // 👈 call after rule changes
                }}
                created={() => {
                  if (qbRef.current) {
                    qbRef.current.setRules(defaultRule);
                    disableFutureDates(); // 👈 call initially
                  }
                }}
 
                showButtons={false}
                summaryView={false}
              />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                <ButtonComponent
                  cssClass="btn-negative"
                  onClick={() => {
                    if (qbRef.current) {
                      qbRef.current.setRules(defaultRule);
                      currentRuleRef.current = defaultRule;
                    }
                 
                    // fetchExams(null, '', getStatusValue(), 1);
                    setFilterRule(null);
                    setSearchQuery('');
                    setFromDate('');
                    setToDate('');
                    setCurrentPage(1);
                    fetchExams(null, "", getStatusValue(), 1);
                  }}
 
                >
                  Clear Filters
                </ButtonComponent>
                <ButtonComponent cssClass="btn" onClick={applyFilters}>
                  Apply Filters
                </ButtonComponent>
              </Box>
            </div>
          )}
 
          {/* TABLE */}
          <div className="pd-table-container">
            {loading ? (
              <div className="pd-table-loading">
                <div className="pd-table-loading-animation">
                  <img
                    className="pd-table-loading-video"
                    src="/images/breath1.gif"
                    alt="Loading exams..."
                  />
                  <p>Loading exams...</p>
                </div>
              </div>
            ) : (
              <div className="pd-table-wrapper">
                <table className="pd-table">
                  <thead>
                    <tr>
                      <th className="sortable-th">
                        <div className="th-wrapper">
                          <span className="th-title">Title</span>
 
                        </div>
                      </th>
                      <th className="sortable-th">
                        <div className="th-wrapper">
                          <span className="th-title">Exam Number</span>
 
                        </div>
                      </th>
 
                      <th className="sortable-th">
                        <div className="th-wrapper">
                          <span className="th-title">Exam Type</span>
 
                        </div>
                      </th>
 
                      <th>
                        <div className="th-wrapper">
                          <span className="th-title">Genre</span>
                        </div>
                      </th>
 
                      <th>
                        <div className="th-wrapper">
                          <span className="th-title">Difficulty</span>
                        </div>
                      </th>
 
                      <th className="sortable-th">
                        <div className="th-wrapper">
                          <span className="th-title">Created On</span>
 
                        </div>
                      </th>
                      <th className="sortable-th">
                        <div className="th-wrapper">
                          <span className="th-title">Created By</span>
 
                        </div>
                      </th>
                      {/* <th>Actions</th> */}
                      {!isLookup && <th>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {sortedRows.length === 0 ? (
                      <TableEmptyRow colSpan={isLookup ? 7 : 8} message={`No ${statusFilter.toLowerCase()} exams found`} />
                    ) : sortedRows.map((exam, idx) => (
                      <tr
                        key={idx}
                        onClick={(e) => handleRowClick(exam, e)}
                        style={{ cursor: 'pointer' }}
                        className="selectable-row"
                      >
                        <td>{exam.Title || 'Untitled'}</td>
                        <td>{exam.ExamNumber || 'N/A'}</td>
 
                        <td>{exam.ExamType || '-'}</td>
                        <td>{exam.Genre || '-'}</td>
                        <td>{exam.Difficulty || '-'}</td>
                        {/* <td>
                          {exam.Created_On
                            ? new Date(exam.Created_On).toISOString().split('T')[0]
                            : '-'}
                        </td> */}
                        <td>
  {exam.Created_On
    ? new Date(exam.Created_On)
        .toLocaleDateString('en-GB')
        .replace(/\//g, '-')
    : '-'}
</td>
                        <td> {exam.Created_By_Name || '-'}</td>
                        {!isLookup && (
                          <td onClick={(e) => e.stopPropagation()}>
                            <div className="action-wrapper">
                              {!authLoading && permissionLevel >= 1 && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/managers/create-course/${exam.ExamTypeId}/${exam.Id}`, {
                                      state: { mode: 'edit' }
                                    });
                                  }}
                                  className="pd-action-btn action-btn"
                                  title={permissionLevel === 2 ? 'Edit' : 'View'}
                                >
                                  {permissionLevel === 2 ? (
                                    <FaPen className="action-icon" />
                                  ) : (
                                    <FaEye className="action-icon" />
                                  )}
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
 
          {/* PAGINATION */}
          {!loading && totalPages > 1 && (
            <div className="pd-pagination">
              <button
                className="btn-negative"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Previous
              </button>
              <div className="pd-page-numbers">
                {pageNumbers.map((num) => (
                  <button
                    key={num}
                    className={`pg-type-btn ${currentPage === num ? 'active' : ''}`}
                    onClick={() => handlePageChange(num)}
                  >
                    {num}
                  </button>
                ))}
              </div>
              <button
                className="btn-negative"
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
 
